module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Cap-2-bbf31d50da4c152867c62ed19f012b2b9dc4b46eec5845693916c5c5c6f5427f.svg";